/* Keep cross-document Collection transitions from exposing fallback font/gallery layout.
   This module is render-blocking only on collection/product views, and always times out. */
let poll, deadline;
try {
    const galleriesReady = new Promise(resolve => {
        const check = () => {
            const cards = [...document.querySelectorAll('.catalog-card[data-product-id]')];
            if (cards.every(card => card.querySelector('.product-gallery'))) resolve();
            else poll = setTimeout(check, 16);
        };
        check();
    });
    await Promise.race([
        Promise.all([
            document.fonts.load('400 16px "VA Sans"'),
            document.fonts.load('700 16px "VA Sans"'),
            document.fonts.load('700 16px "VA Spine"'),
            galleriesReady
        ]),
        new Promise(resolve => { deadline = setTimeout(resolve, 1500); })
    ]);
} catch { /* Native HTML remains usable if a font or resource fails. */ }
finally { clearTimeout(poll); clearTimeout(deadline); }
